import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import {
  // updateProfileFieldsInDb,
  updateTransactionInDb,
} from "../../../../app/firestore/firestoreService";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../app/common/modals/modalSlice";

export default function ManagerUpcomingActionButtons({ transaction, agent }) {
  const navigate = useNavigate();
  const { currentUserProfile } = useSelector((state) => state.profile);
  const brokerageDetails = currentUserProfile.brokerage;
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const dispatch = useDispatch();

  function handleViewClosingDisbursement() {
    dispatch(
      openModal({
        modalType: "ManagerEditClosingDisbursement",
        modalProps: { transaction, agent, brokerageDetails },
      })
    );
  }

  function handleViewDynamicClosingDisbursement() {
    dispatch(
      openModal({
        modalType: "ManagerEditClosingDisbursementDynamic",
        modalProps: { transaction, agent, brokerageDetails },
      })
    );
  }
  // function handleDownloadClosingDisbursement() {}

  function handleGoToAgentTransactions() {
    navigate(`/agent/${agent.id}/transactions`);
  }

  function handleGoToAgentDashboard() {
    navigate(`/agent/${agent.id}/overview`);
  }

  // async function handleMakeActive() {
  //   try {
  //     await updateProfileFieldsInDb(agent.id, {
  //       managerActive: true,
  //     });
  //     toast.success("Agent successfully made active");
  //   } catch (error) {
  //     toast.error(error.message);
  //   }
  // }

  // function handleEditAgentFinancials() {
  //   dispatch(
  //     openModal({
  //       modalType: "ManagerAgentFinancialsEditForm",
  //       modalProps: { agent },
  //     })
  //   );
  // }

  // async function handleMakeInactive() {
  //   try {
  //     await updateProfileFieldsInDb(agent.id, {
  //       managerActive: false,
  //     });
  //     toast.success("Agent successfully made inactive");
  //   } catch (error) {
  //     toast.error(error.message);
  //   }
  // }

  async function handleCdaStatus() {
    try {
      const newStatus = transaction.cdaComplete === true ? false : true;
      await updateTransactionInDb(
        transaction.id,
        {
          cdaComplete: newStatus,
        },
        true
      );
      toast.success("CDA status updated");
    } catch (error) {
      toast.error(error.message);
    } finally {
    }
  }

  // async function handleRemove(agent) {
  //   try {
  //     await updateProfileFieldsInDb(agent.id, {
  //       managerId: null
  //     });
  //     setConfirmOpen(false);
  //     toast.success("Agent successfully removed");
  //   } catch (error) {
  //     toast.error(error.message);
  //   }
  // }

  return (
    <div className={isMobile ? null : "text align right"}>
      <Dropdown
        button
        icon="chevron down"
        text={isMobile ? "Actions " : null}
        className={isMobile ? "button icon" : "button mini icon"}
        direction={isMobile ? "right" : "left"}
      >
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => handleViewClosingDisbursement()}>
            Create Closing Disbursement
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleViewDynamicClosingDisbursement()}>
            Create Dynamic Closing Disbursement
          </Dropdown.Item>
          {/* <Dropdown.Item onClick={() => handleDownloadClosingDisbursement()}>
            Download Closing Disbursement
          </Dropdown.Item> */}
          <Dropdown.Item onClick={() => handleCdaStatus()}>
            Mark CDA Complete
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleGoToAgentTransactions()}>
            View Transactions
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleGoToAgentDashboard()}>
            View Dashboard
          </Dropdown.Item>
          {/* <Dropdown.Item onClick={() => handleEditAgentFinancials()}>
            Edit Financials
          </Dropdown.Item> */}
          {/* {agent.managerId === currentUserProfile.userId && (
            <>
              {agent.managerActive === true ? (
                <Dropdown.Item onClick={() => handleMakeInactive()}>
                  Make Inactive
                </Dropdown.Item>
              ) : (
                <Dropdown.Item onClick={() => handleMakeActive()}>
                  Make Active
                </Dropdown.Item>
              )}
            </>
          )} */}
          {/* <Dropdown.Item
            onClick={() => setConfirmOpen(true)}
          >
            Remove
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>
      {/* <Confirm
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={() => handleRemove(agent)}
      ></Confirm> */}
    </div>
  );
}